import NotesInputField from 'ext-ui/components/NotesInputField/NotesInputField'
import Pill from 'ext-ui/components/Pill/Pill'
import React, { useEffect } from 'react'
import SvgCheckFilled from 'src/components/Svgs/SvgCheckFilled'
import { useTranslate } from 'src/localization/Trns'
import { FormProps } from 'src/types'

import styles from './NotesInput.style'

interface NotesInputProps {
  className?: string
  notesProps: FormProps<string> & {
    puttingNotes?: boolean
    puttingNotesComplete?: boolean
    puttingNotesError?: string
  }
  id?: string
  maxLength?: number
  notesCharacters?: number
  isExpense?: boolean
  collapsible?: boolean
  showMissingTag?: boolean
}

const NotesInput: React.FC<NotesInputProps> = (props): React.ReactElement => {
  const translate = useTranslate()

  const fadeOutAnimationDurationInMs = 5000
  const [showSaving, setShowSaving] = React.useState(false)
  const [showComplete, setShowComplete] = React.useState(false)

  useEffect(() => {
    if (props.notesProps.puttingNotesComplete) {
      setShowSaving(false)
      setShowComplete(true)
      setTimeout(() => {
        setShowComplete(false)
      }, fadeOutAnimationDurationInMs)
    }
  }, [props.notesProps.puttingNotesComplete])

  interface LabelProps {
    loading: boolean
    complete: boolean
  }

  const StatusLabel: React.FC<LabelProps> = (
    labelProps,
  ): React.ReactElement => {
    return (
      <div key={'status'}>
        {labelProps.loading ? (
          <span className="NotesInput-status saving">
            {translate('Saving...')}
          </span>
        ) : labelProps.complete ? (
          <>
            {props.notesProps.puttingNotesError ? (
              <span className="NotesInput-status error">
                {props.notesProps.puttingNotesError}
              </span>
            ) : (
              <span className="NotesInput-status saved">
                <SvgCheckFilled />
                {translate('Saved!')}
              </span>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    )
  }

  return (
    <div css={styles} className="NotesInput">
      <div className="NotesInput-header font-h3">
        <span>{translate('Notes')}</span>
        {props.showMissingTag &&
          (props.notesProps.value || '').length === 0 && (
            <Pill size={'small'} color={'severe'}>
              {translate('Missing')}
            </Pill>
          )}
        <StatusLabel
          loading={showSaving || !!props.notesProps.puttingNotes}
          complete={showComplete}
        />
      </div>
      <NotesInputField
        showUpdates={props.notesProps.showUpdates}
        baseValue={props.notesProps.baseValue}
        value={props.notesProps.value}
        onChange={props.notesProps.onChange}
        placeholder={translate('Add a quick note...')}
        id={props.id}
        maxLength={props.maxLength}
        notesCharacters={props.notesCharacters}
        showSaving={showSaving && props.notesProps.puttingNotes !== undefined}
        setShowSaving={
          props.notesProps.puttingNotes !== undefined
            ? setShowSaving
            : undefined
        }
        variant={
          props.showMissingTag && (props.notesProps.value || '').length === 0
            ? 'severe'
            : undefined
        }
      />
    </div>
  )
}

export default NotesInput
